import { Data } from '@telstra-connect/utils';
import { State as LoginState } from '@telstra-connect/login';

export function getProfileFromAuthToken(userState: LoginState.IUserState) {
    try {
        // Token issuer is checked againest OKAPI SSO issuer URI
        return userState.oauth.authIssuer === `https://api.in.telstra.com.au/sso` ? Data.UserType.staffUser : Data.UserType.customerUser;
    } catch (error) {
        return Data.UserType.customerUser;
    }
}
